<template>
  <v-container fluid>
    <ClientsSearch />
    <v-flex xs12>
      <ClientsList :clients="clientsList" />
    </v-flex>
    <v-flex v-if="totalPages && totalPages > 1" xs12 text-xs-center pt-4>
      <v-pagination
        v-model="currentPage"
        :length="totalPages"
        :disabled="busy"
      ></v-pagination>
    </v-flex>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClientsList from '../components/Clients/ClientsList.vue';
import ClientsSearch from '../components/Clients/Search.vue';

export default {
  name: 'clients',
  data: () => ({
    page: 1,
    busy: false,
  }),
  components: {
    ClientsList,
    ClientsSearch,
  },
  computed: {
    ...mapGetters('clients', [
      'clientsList',
      'totalPages',
      'query',
    ]),
    currentPage: {
      get() {
        return parseInt(this.$route.params.page, 0);
      },
      set(page) {
        this.setCurrentPage(page);
        this.$router.push({ path: `/klienci/${page}`, query: this.query });
      },
    },
  },
  methods: {
    ...mapActions('clients', [
      'getClientsList',
      'setQuery',
      'setCurrentPage',
    ]),
    getList() {
      const { query, params } = this.$route;
      const page = parseInt(params.page, 0);
      this.setQuery(query);
      this.setCurrentPage(page);
      this.getClientsList();
    },
  },
  beforeDestroy() {
    this.setQuery(null);
  },
  mounted() {
    this.getList();
  },
  watch: {
    $route() {
      this.getList();
    },
  },
};
</script>
